import { Outlet } from 'react-router-dom';

export default function Auth() {
  document.documentElement.dir = "ltr";
    return (
      <div className="flex h-full w-full">
        <div className="h-full w-full bg-lightPrimary dark:!bg-intsamis-900">
          {/* Main Content */}
          <main
            className={`max-w-[800px] mx-auto h-full flex-none transition-all`}
          >
            <div className="h-full">
              <div className="pt-5s mx-auto mb-auto h-full min-h-[100vh] p-2 md:pr-2">
                <Outlet/>
              </div>
              <div className="p-3">
              </div>
            </div>
          </main>
        </div>
      </div>
  );
}
